import React, { useEffect, useState } from 'react';
import { onToast } from '../hooks/useToast';

const STYLES = {
  success: {
    background: 'var(--color-success-dim)',
    color: 'var(--color-success)',
    border: '1px solid var(--color-success-border)',
  },
  error: {
    background: 'var(--color-danger-dim)',
    color: 'var(--color-danger)',
    border: '1px solid var(--color-danger-border)',
  },
  info: {
    background: 'var(--accent-dim)',
    color: 'var(--accent)',
    border: '1px solid var(--border-accent)',
  },
};

const ICONS = { success: '✓', error: '⚠', info: 'ℹ' };

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return onToast((e) => {
      const toast = e.detail;
      setToasts((prev) => [...prev, toast]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, 3000);
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed top-4 right-4 z-[9999] flex flex-col gap-2"
      style={{ pointerEvents: 'none' }}
    >
      {toasts.map((toast) => {
        const style = STYLES[toast.type] || STYLES.info;
        return (
          <div
            key={toast.id}
            className="px-4 py-2.5 rounded-xl text-sm font-bold flex items-center gap-2"
            style={{
              ...style,
              backdropFilter: 'blur(12px)',
              boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
              fontFamily: 'Outfit, sans-serif',
              animation: 'slideInRight 0.2s ease',
            }}
          >
            <span>{ICONS[toast.type] || ICONS.info}</span>
            {toast.message}
          </div>
        );
      })}
    </div>
  );
}
